import { atomWithStorage } from "jotai/utils";
import {
	RecentTimelineItemTypeFilterEnum,
	TimelineHorizonEnum,
	TimelineItemSubcategoryEnum,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";

export type TimelineFilterState = {
	horizon: TimelineHorizonEnum;
	recentType: RecentTimelineItemTypeFilterEnum;
	upcomingType: UpcomingTimelineItemTypeFilterEnum;
	recentDocumentsOnly?: boolean;
	upcomingDocumentsOnly?: boolean;
};

export const DOCUMENT_FILTER_SUBCATEGORIES: TimelineItemSubcategoryEnum[] = [
	TimelineItemSubcategoryEnum.IdentificationDocumentExpiring,
	TimelineItemSubcategoryEnum.IdentificationDocumentExpired,
	TimelineItemSubcategoryEnum.ReminderIdentificationDocument,
	TimelineItemSubcategoryEnum.IdentificationDocumentExpiry,
	TimelineItemSubcategoryEnum.ReminderTerm,
];

export const DEFAULT_TIMELINE_FILTER: TimelineFilterState = {
	horizon: TimelineHorizonEnum.HalfYear,
	recentType: RecentTimelineItemTypeFilterEnum.All,
	upcomingType: UpcomingTimelineItemTypeFilterEnum.All,
};

const STORAGE_KEY = "myplann-notification-center-filter-v2";

export const timelineFilterAtom = atomWithStorage<TimelineFilterState>(
	STORAGE_KEY,
	DEFAULT_TIMELINE_FILTER,
);
